import { Injectable } from '@angular/core';
import { CalculationService } from '../../calculation.service';
import { Offer } from '../../../../models/offer/offer.model';
import { ApplicationStateService } from '../../../../../shared/services/application-state.service';
import {OfferCoverage} from '../../../../models/offer/offer-coverage.model';
import {OfferPrimaryCoverageCode} from '../../../../consts/offer-primary-coverage-code.enum';

@Injectable()
export class SelectedOfferService {

  private _offer: Offer;

  constructor(private calculation: CalculationService,
              private applicationStateService: ApplicationStateService) {
  }

  get hasModifications(): boolean {
    return this.selectedOffer && this.selectedOffer.modifications && this.selectedOffer.modifications.length > 0;
  }

  get selectedOffer(): Offer {
    return this.applicationStateService.selectedOffer;
  }

  get selectedOfferNotModified(): Offer {
    return this.applicationStateService.selectedOfferNotModified;
  }

  get offer(): Offer {
    return this._offer;
  }

  set offer(value: Offer) {
    this._offer = value;
  }

  get coverages(): OfferCoverage[] {
    return this.selectedOffer ? this.selectedOffer.coverages : [];
  }

  set coverages(coverages: OfferCoverage[]) {
    if (this.selectedOffer) {
      this.selectedOffer.coverages = coverages;
    }
  }

  hasAC(): boolean {
    const acCoverage = this.selectedOffer.coverages.find(({ code }) => code === OfferPrimaryCoverageCode.AC);
    return acCoverage ? acCoverage.destinies[0].selectedOption.endsWith('YES') : false;
  }

  hasACOrACMini(): boolean {
    if (this.hasAC()) {
      return true;
    }
    const acMiniCoverage = this.selectedOffer.coverages.find(({ code }) => code === OfferPrimaryCoverageCode.AC_MINI);
    return acMiniCoverage ? acMiniCoverage.destinies[0].selectedOption.endsWith('YES') : false;
  }
}
